/* RESPONSIBLE TEAM: team-workflows */
import type TriggerWorkflow from 'embercom/models/operator/visual-builder/step/trigger-workflow';
import StepConfig, { type StepConfigParams } from '../step';

export default class TriggerWorkflowConfiguration extends StepConfig {
  declare step: TriggerWorkflow;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/trigger-workflow',
      ...params,
    });
  }
}
